<template>
    <span>

    <v-card-text class="pb-0">
        <v-form ref="visaTransferForm">
            <v-layout class="px-4 pt-2" row wrap>
<!--                 <v-flex xs12>-->
              <!--                    <v-alert-->
              <!--                        type="info"-->
              <!--                    >-->
              <!--                      <b>FOR TRANSFER VISA FROM YOUR EXPIRED/LOST/DAMAGED DOCUMENT(PASSPORT/TRAVEL DOCUMENT) TO NEW ONE</b>-->
              <!--                    </v-alert>-->
              <!--                    </v-flex>-->
                <v-flex xs12>
                    <v-alert
                        outlined
                        type="info">
                        Your visa transfer cost will be <strong>USD($)
                        {{ extendConvertVisaDetail.visa_transfer_cost }}</strong>
                    </v-alert>
                </v-flex>

                <v-flex xs6>
                    <v-select
                        :items="transfer_document_type"
                        :label="$vuetify.lang.t('$vuetify.transfer_document_type')"
                        :rules=[rules.required]
                        class="pr-2"
                        item-text="name"
                        item-value="id"
                        min="0"
                        outlined
                        v-model="visaTransferData.document_type"
                    ></v-select>
                </v-flex>

                <v-flex xs6>
                    <v-text-field
                        :label="'New '  + visaTransferData.document_type + $vuetify.lang.t('$vuetify.transfer_document_number')"
                        :rules=[rules.required]
                        class="pr-2"
                        outlined
                        type="text"
                        v-model="visaTransferData.document_number"
                    ></v-text-field>
                </v-flex>
                <v-flex md6 xs6 class="pr-2">
                                        <v-autocomplete
                                            :clearable="true"
                                            :items="countries"
                                            :label="$vuetify.lang.t('$vuetify.select_document_holding_country')+' *'"
                                            :rules="[rules.required]"
                                            id="selectCountry"
                                            item-text="country_name"
                                            item-value="id"
                                            outlined
                                            v-model="visaTransferData.document_country_id"
                                        />
                                    </v-flex>
                <v-flex class="pl-3 pr-5" xs6>
                      <date-picker-new
                          :max-year="getCurrentYear+30"
                          :min-year="getCurrentYear"
                          label="Document Expiry Date * "
                          v-model="visaTransferData.document_validity"
                      />
                </v-flex>
                <v-flex xs6>
                    <v-select
                        :items="reason_for_transfer"
                        :label="$vuetify.lang.t('$vuetify.reason_for_transfer')"
                        :rules=[rules.required]
                        class="pr-2"
                        outlined
                        v-model="visaTransferData.reason_for_transfer"
                    ></v-select>
                </v-flex>
              <v-flex xs6>
                   <file-input label="Recommendation Letter" :show-image="true"
                               :fileSize="6144"
                               v-model="visaTransferData.recommendation_letter"
                               :valid_file_types="['jpg','jpeg','png','pdf','doc','docx']"></file-input>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card-text>
    <v-card-actions class="d-flex justify-end">
        <v-btn @click="submitTransfer"
               color="error"
               large
        >
            {{ $vuetify.lang.t('$vuetify.back') }}
        </v-btn><v-btn @click="submitTransfer"
                       class="mr-3"
                       color="primary"
                       large
    >
            {{ $vuetify.lang.t('$vuetify.proceed') }}
        </v-btn>
    </v-card-actions>
            </span>

</template>

<script>
import DatePickerNew from "../../components/DatePickerNew";
import {mapActions, mapGetters} from "vuex";
import {validationMixin} from "../../mixins/validationMixin";
import {fetchDynamicValues} from "../../helpers/dynamicValueHelper";
import FileInput from "@/components/FileInput";

export default {
  name: "VisaTransferForm",
  computed: {
    ...mapGetters('VisaSingle', ['visaTransferData', 'extendConvertVisaDetail']),
    ...mapGetters({countries:'CountryForTouristList/all'}),
    showRecommendation() {
      return false;
    },
    getCurrentYear() {
      return new Date().getFullYear();
    }
  },
  props: ['convert'],
  data() {
    return {
      transfer_document_type: ['Passport ', 'Travel Document ', 'Stay Order Document'],
      reason_for_transfer: []
    }
  },
  mixins: [validationMixin],
  components: {
    FileInput,
    DatePickerNew
  },
  methods: {
    ...mapActions("CountryForTouristList", ['fetchAll']),
    submitTransfer() {
      if (this.$refs.visaTransferForm.validate()) {
        this.$router.push({
          name: 'VisaTransferConfirm'
        })
      }
    },
    backBtnClicked() {
      this.$router.go(-1);
    },
  },
  mounted() {
    fetchDynamicValues('ReasonForTransfer').then((data) => {
      this.reason_for_transfer = data;
    })
  }
}
</script>

